import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { estimateTemplateEndpoints } from '@/lib/api/endpoints';
import { estimateTemplateKeys } from '@/lib/queryKeys';
import type { EstimateTemplateListResponse } from '@/types/estimateTemplate';

export interface UseEstimateTemplatesParams {
  search?: string;
  limit?: number;
  page?: number;
  /**
   * Narrow to templates offered to this Business Unit. Omitted means NO
   * predicate — every template, exactly as before business units existed.
   * The server's filter is wildcard-aware: a template with no business units
   * belongs to all of them.
   */
  businessUnitId?: string;
}

export interface UseEstimateTemplatesOptions {
  enabled?: boolean;
}

export function useEstimateTemplates(
  params: UseEstimateTemplatesParams = {},
  options?: UseEstimateTemplatesOptions,
) {
  return useApiQuery<EstimateTemplateListResponse>({
    queryKey: estimateTemplateKeys.list(params),
    enabled: options?.enabled,
    queryFn: () =>
      apiGet<EstimateTemplateListResponse>(operationsClient, estimateTemplateEndpoints.list(), {
        params: {
          ...(params.search ? { search: params.search } : {}),
          // Omitted entirely when unset — an empty string would be a filter.
          ...(params.businessUnitId ? { businessUnitId: params.businessUnitId } : {}),
          limit: params.limit ?? 50,
          page: params.page ?? 1,
        },
      }),
    showErrorToast: false,
  });
}
